module.exports = __webpack_public_path__ + "static/media/popup.3b84f9cd.png";